/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type GetReportsBurnRateTransactionsParamsSortDir = typeof GetReportsBurnRateTransactionsParamsSortDir[keyof typeof GetReportsBurnRateTransactionsParamsSortDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportsBurnRateTransactionsParamsSortDir = {
  GetReportsBurnRateTransactionsParamsSortDirAsc: 'asc',
  GetReportsBurnRateTransactionsParamsSortDirDesc: 'desc',
} as const;
